import React, { useContext, useEffect, useState } from "react";
import { SessionContext } from "../../context/SessionContext";
import { getSubscriptions } from "../../api/settings/Settings";
import { rentalCopy } from "../../api/mw/rental";
import { loadRequest } from "../../utils/loadRequest";
import { flowCopy } from "../../utils/flowCopy";
import "./PackageList.scss";

export default function PackageList() {
  const { profile } = useContext(SessionContext);
  const [packages, setPackages] = useState([]);
  const [status, setStatus] = useState("loading");
  const [retry, setRetry] = useState(0);
  const copy = rentalCopy();
  useEffect(() => {
    let active = true;
    setStatus("loading");
    loadRequest(getSubscriptions)
      .then(({ data }) => {
        if (data?.IsSucceeded === false) throw new Error("Subscription request failed");
        data = data?.Data ?? data;
        if (!Array.isArray(data))
          throw new Error("Invalid subscription response");
        if (active) {
          setPackages(data);
          setStatus("ready");
        }
      })
      .catch(() => {
        if (active) setStatus("error");
      });
    return () => {
      active = false;
    };
  }, [retry, profile?.id]);

  if (status === "loading")
    return (
      <div className="settings-empty" role="status">
        {flowCopy().loading}
      </div>
    );
  if (status === "error")
    return (
      <div className="settings-empty" role="alert">
        <p>{flowCopy().loadError}</p>
        <button
          className="plan-detail-btn"
          onClick={() => setRetry((value) => value + 1)}
        >
          {flowCopy().retry}
        </button>
      </div>
    );
  if (!packages.length)
    return (
      <p className="settings-empty" role="status">
        {copy.emptyPackages}
      </p>
    );
  return (
    <ul className="account-packages">
      {packages.map((item) => (
        <li key={item.UId} className="account-package">
          <header>
            <h2>{item.OfferTitle}</h2>
            <span className="account-package-status">
              {item.IsCanceled
                ? copy.canceled
                : item.IsSuspended
                ? copy.suspended
                : item.IsExpired
                ? copy.expired
                : item.IsActive
                ? copy.active
                : copy.inactive}
            </span>
          </header>
          {item.OfferDescription && <p>{item.OfferDescription}</p>}
          {item.OfferPeriodTitle && <h3>{item.OfferPeriodTitle}</h3>}
          {item.OfferPeriodDescription && <p>{item.OfferPeriodDescription}</p>}
          <dl>
            <div>
              <dt>{copy.start}</dt>
              <dd>{item.StartDate || "—"}</dd>
            </div>
            <div>
              <dt>{copy.endDate}</dt>
              <dd>{item.EndDate || "—"}</dd>
            </div>
          </dl>
        </li>
      ))}
    </ul>
  );
}
